export default __webpack_public_path__ + "static/media/dj.752725d8.jpg";